// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__BYf50","outsideButtonContainer":"styles_outsideButtonContainer__ymVzT"};